export const profileInfoItemStyles = {
  container: {
    display: 'flex',
    alignItems: 'flex-start',
    mb: 3,
    p: 2,
    borderRadius: 2,
    backgroundColor: theme =>
      theme.palette.mode === 'dark' ? 'grey.800' : 'grey.50',
    border: '1px solid',
    borderColor: theme =>
      theme.palette.mode === 'dark' ? 'grey.700' : 'grey.200',
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: theme =>
        theme.palette.mode === 'dark' ? 'grey.700' : 'grey.100',
      transform: 'translateX(4px)',
    },
  },

  getHoverBorderColor: (color) => ({
    '&:hover': {
      borderColor: color,
    },
  }),

  iconContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 40,
    height: 40,
    borderRadius: 2,
    backgroundColor: theme =>
      theme.palette.mode === 'dark' ? 'grey.900' : 'white',
    mr: 2,
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
    flexShrink: 0,
  },

  content: {
    flex: 1,
    minWidth: 0,
  },

  label: {
    mb: 0.5,
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: 0.5,
    display: 'block',
    color: theme =>
      theme.palette.mode === 'dark' ? 'grey.400' : 'text.secondary',
  },

  value: {
    fontWeight: 500,
    wordBreak: 'break-word',
    lineHeight: 1.4,
    color: theme =>
      theme.palette.mode === 'dark' ? 'grey.100' : 'text.primary',
  },

  emptyValue: {
    color: theme =>
      theme.palette.mode === 'dark' ? 'grey.500' : 'text.disabled',
    fontStyle: 'italic',
    fontSize: '0.9rem',
  },
}; 